export default function findMatchedPage(pages) {
  let matchedPage = null
  pages.some((page) => {
    let isMatch = false
    const urlString = window.location.pathname + window.location.search
    if (page.pattern === 'equal') {
      isMatch = page.matched_url === urlString || page.matched_url === window.location.href
    } else if (page.pattern === 'contain') {
      isMatch = window.location.href.includes(page.matched_url)
    } else if (page.pattern === 'start_with') {
      isMatch =
        urlString.startsWith(page.matched_url) || window.location.href.startsWith(page.matched_url)
    }
    if (isMatch && page.type !== 'exception') {
      matchedPage = page
    }
    return isMatch
  })
  return matchedPage
}
